import { render, staticRenderFns } from "./PathologyForm.vue?vue&type=template&id=0a2c2006&scoped=true"
import script from "./PathologyForm.vue?vue&type=script&lang=js"
export * from "./PathologyForm.vue?vue&type=script&lang=js"
import style0 from "./PathologyForm.vue?vue&type=style&index=0&id=0a2c2006&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2c2006",
  null
  
)

export default component.exports